import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/services'

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
  recentConversations: () => [...dashboardKeys.all, 'recentConversations'] as const,
  trends: (days: number) => [...dashboardKeys.all, 'trends', days] as const,
}

export const useDashboardStats = () => {
  return useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: () => dashboardApi.getStats(),
    staleTime: 30 * 1000,
    retry: 2,
  })
}

export const useRecentConversations = (limit = 10) => {
  return useQuery({
    queryKey: dashboardKeys.recentConversations(),
    queryFn: () => dashboardApi.getRecentConversations(limit),
    staleTime: 60 * 1000,
  })
}

export const useDashboardTrends = (days = 7) => {
  return useQuery({
    queryKey: dashboardKeys.trends(days),
    queryFn: () => dashboardApi.getTrends(days),
    staleTime: 5 * 60 * 1000,
  })
}
